import React from 'react';
import PropTypes from 'prop-types';
// TODO: (DDS-128)Remove this LinkListArrow Component and use the one from the DS

const propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node.isRequired,
      href: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      target: PropTypes.string,
    }).isRequired,
  ).isRequired,
};

function LinkListArrow({
  links,
}) {
  return (
    <ul className="link-list-arrow">
      {links.map(({
        children,
        href,
        key,
        target,
      }) => (
        <li key={`linklistarrow-${key}`}>
          <a
            href={href}
            rel={target && 'noreferrer noopener'}
            target={target}
          >
            <span className="icon-link-text">
              {children}
              <span
                aria-hidden="true"
                className="link-arrow"
                data-testid="link-arrow"
              />
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}

LinkListArrow.propTypes = propTypes;

export default LinkListArrow;
